<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_5">Dedication</a></p><a id="page_5">
<p class="noindent1">To J. Michael Orenduff, an award-winning, exquisite writer and talented storyteller, who is also a mentor to other writers. He is so generous with his time, and because of him, others like me have a chance to succeed in this crazy writing world.</p>
<p class="noindent1">Mike, you are the best.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?78b64795